import type { ReactNode } from "react"

import { Spinner } from "../.."

import styles from "./index.module.css"
import { usePwaRefresh } from "./usePwaRefresh"

export type PwaRefreshProps = {
  children: ReactNode
}

const MAX_PULL = 150

export const PwaRefresh = ({ children }: PwaRefreshProps) => {
  const { containerRef, pullDistance, isRefreshing } = usePwaRefresh()

  const showIndicator = pullDistance > 0 || isRefreshing
  const opacity = Math.min(pullDistance / 100, 1)

  return (
    <>
      {showIndicator && (
        <div
          className={styles.ptrIndicator}
          style={{
            transform: `translateY(${Math.min(pullDistance, MAX_PULL)}px)`,
            opacity,
          }}
        >
          <div className={styles.ptrBubble}>
            <Spinner size="xl" />
          </div>
        </div>
      )}

      <div ref={containerRef}>{children}</div>
    </>
  )
}
